<rid-mechanic-background />

<rid-mechanic-wrapper>
  <rid-top-bar [progress]="index()" [steps]="numbers().length" class="block w-full" name="Flitsen met getallen" />

  <rid-mechanic-content>
    <rid-mechanic-title [title]="'Welk getal lees je?'" />

    <div class="grid place-items-center">
      <rid-content-card class="absolute">
        <div class="bg-card-background relative h-48 rounded-lg p-4 text-center font-normal">
          @for (num of [formattedNumber()]; track num) {
            <p aria-hidden="true" class="font-lexy2000s invisible text-8xl font-black whitespace-nowrap">{{ num }}</p>

            <h1
              [class.invisible]="state() === 'HIDDEN'"
              [class.text-emerald-500]="state() === 'ANSWER'"
              animate.enter="anim-pop-in"
              animate.leave="anim-fade-out"
              class="font-lexy2000s absolute inset-0 flex items-center justify-center text-8xl font-black text-black drop-shadow-2xl transition-all"
            >
              {{ num }}
            </h1>
          }
        </div>
      </rid-content-card>
    </div>

    @if (state() === 'ANSWER') {
      <rid-assessment-toast (assessed)="$event === 'CORRECT' ? markCorrect() : markIncorrect()" />
    }
  </rid-mechanic-content>
</rid-mechanic-wrapper>
